import { render } from "./index.vue?vue&type=template&id=1a39c4d3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1a39c4d3&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1a39c4d3"

export default script